module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/id-0b7fa609d99165dc53779622ac443791.svg";